import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledPredefinedAdditionalText = styled.p(
    ({theme: {palette, spacing, typography}}) => css`
        ${typography.textSm};
        width: 100%;
        border-radius: 6px;
        background-color: ${palette.neutral[50]};
        outline: 1px solid ${palette.neutral[200]};
        padding: ${spacing * 3}px;
    `
)

export const StyledPredefinedAdditionalTextsFields = styled(Flexbox)`
    .reopening-checkbox-container label {
        font-weight: 500;
    }
`
